module.exports = __webpack_public_path__ + "img/supplier-000.70363ae4.png";